import { SelectProps } from 'antd';
import { isEmpty } from 'lodash';
import { FC } from 'react';
import { Select } from '~/components';
import { useHandbook, useHandbookKeys } from '~/controllers/handbook';
import { SelectChevronIcon } from '~/img';

interface MccCodeSelectProps {
  mccGroupValue?: string;
  withCode?: boolean;
}

const MccCodeSelect: FC<MccCodeSelectProps & SelectProps<any>> = (props) => {
  const { withCode } = props;
  const { data: handbook, isLoading: handbookIsLoading } = useHandbook();

  const additionalParamsGroup = handbook?.handbooks
    ?.find((item) => item.key === 'mcc')
    ?.values?.flatMap((groupItem) => groupItem.values)
    ?.flatMap((groupItem: any) => groupItem.values);

  const options = additionalParamsGroup?.map((item: any) => ({
    label: withCode ? `${item.localizedValue} (${item.apiValue})` : item.localizedValue,
    value: item.apiValue,
    key: item.key,
  }));
  return (
    <Select
      showSearch
      loading={handbookIsLoading}
      // disabled={isEmpty(additionalParamsGroup)}
      options={options}
      suffixIcon={<SelectChevronIcon />}
      {...props}
      style={{ maxWidth: '90vw' }}
    />
  );
};

export default MccCodeSelect;
